import _ from 'lodash';
import { QUICKSEARCH_DISABLE_COUNTRIES } from '../constants';

export function isQuickSearchDisabled(isoCode: string) {
    return _.includes(QUICKSEARCH_DISABLE_COUNTRIES, isoCode);
}
